import { Form, Modal, Button,  message, Checkbox } from 'antd';
import React, { useEffect, useState } from 'react';
import NumberFormat from 'react-number-format';
import { useValidationShorts } from '../../Hooks/Helpers';
import { maskCpf } from '../../Helpers/Functions';
import { FaRegIdCard, FaStar, FaUser } from 'react-icons/fa';
import { FaTrash } from 'react-icons/all';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useMutation, useQuery } from '@tanstack/react-query';
import useAsyncApi from '../../services/async-api';
import Loading from '../../Components/Generic/Loading';
import { Env } from '../../Helpers/Env';

//Steps -> ADD, LIST

const ModalAddDependent = (props) => {
   const { getFieldDecorator, validateFields } = props.form;
   const { numMinWithMask, isValidDate } = useValidationShorts();
   const api = useAsyncApi();
   const [step, setStep] = useState('LIST');
   const [agree, setAgree] = useState(false);
   const user = useSelector((state) => state).authReducer;

   const getGuardianship = async () => {
      try {
         const response = await api.get(`/user/${user.user_id}/guardianship`);
         if (response.length === 0) {
            setStep('ADD');
         } else {
            setStep('LIST');
         }
         return {
            tutor: response.filter((item) => item.category === 'tutor'),
            dependent: response.filter((item) => item.category === 'dependent'),
            isDependent: response.some((item) => item.category === 'dependent'),
         };
      } catch (e) {}
   };

   const { mutateAsync: onSubmit, isLoading: isFetchingSubmit } = useMutation({
      mutationFn: async (e) => {
         e.preventDefault();
         validateFields(async (err, values) => {
            if (!err && user && agree) {
               const payload = values;
               try {
                  payload.birthdate = moment(values.birthdate, 'DD/MM/YYYY').format('YYYY-MM-DD');
                  payload.add = values.add.replace(/\D/g, '');

                  await api.post(`/user/${user.user_id}/guardianship`, payload);
                  await refetch();
               } catch (e) {
                  message.error(e.message || 'Ocorreu um erro');
               }
            }
         });
      },
   });

   const { mutateAsync: onDelete, isLoading: isFetchingDelete } = useMutation({
      mutationFn: async (variables) => {
         console.log(variables);
         try {
            await api.post(`/user/${user.user_id}/guardianship`, variables);
            await refetch();
         } catch (e) {
            message.error(e.message || 'Ocorreu um erro');
         }
      },
   });

   const { data, isInitialLoading, refetch } = useQuery({
      queryKey: ['guardianship', user?.user_id],
      queryFn: getGuardianship,
      enabled: !!props.visible && !!user?.user_id,
   });

   useEffect(() => {
      if (!props.visible) {
         setAgree(false);
      }
   }, [props.visible]);

   return (
      <Modal
         visible={props.visible}
         footer={null}
         bodyStyle={{ padding: 0 }}
         title={step === 'ADD' ? 'Adicionar Dependente' : 'Dependentes'}
         onCancel={() => {
            props.setVisible(false);
         }}
         className={'registerModalWidth'}
         destroyOnClose={true}
      >
         {isInitialLoading ?
            <div style={{ padding: '20px' }}>
               <Loading />
            </div>
         :  <>
               <div className={'dependent'}>
                  {step === 'ADD' && (
                     <Form onSubmit={onSubmit}>
                        <div>
                           <label htmlFor="dependent_add">Informe o CPF do dependente</label>
                           <Form.Item style={{ marginTop: '5px', marginBottom: 14 }}>
                              {getFieldDecorator('add', {
                                 rules: [
                                    numMinWithMask(11, 'CPF inválido'),
                                    {
                                       required: true,
                                       message: 'Campo Obrigatório',
                                    },
                                 ],
                              })(
                                 <NumberFormat
                                    style={{ width: '100%', marginBottom: 5 }}
                                    placeholder={'Seu CPF'}
                                    className="ant-input ant-input-lg"
                                    format={'###.###.###-##'}
                                    mask="_"
                                 />
                              )}
                           </Form.Item>
                        </div>

                        <div>
                           <label htmlFor="dependent_birthdate">
                              Data de nascimento do dependente
                           </label>
                           <Form.Item style={{ marginTop: '5px', marginBottom: 14 }}>
                              {getFieldDecorator('birthdate', {
                                 rules: [
                                    {
                                       required: true,
                                       message: 'Campo Obrigatório',
                                    },
                                    isValidDate(),
                                 ],
                              })(
                                 <NumberFormat
                                    className={'ant-input ant-input-lg'}
                                    style={{ width: '100%', marginBottom: 5 }}
                                    format="##/##/####"
                                    placeholder="DD/MM/AAAA"
                                 />
                              )}
                           </Form.Item>
                        </div>

                        <Checkbox
                           style={{ fontSize: '0.75rem', marginBottom: 10 }}
                           checked={agree}
                           onChange={() => {
                              setAgree(!agree);
                           }}
                        >
                           Na qualidade de responsável legal, autorizo o cadastro do menor de 16
                           anos na plataforma {Env.application_title}, para fins de candidatura a vagas do
                           programa Jovem Aprendiz.
                        </Checkbox>

                        <Form.Item style={{ marginBottom: 10, textAlign: 'center' }}>
                           <Button
                              loading={isFetchingSubmit }
                              disabled={!agree}
                              type={'primary'}
                              style={{opacity: agree ? 1 : 0.7}}
                              htmlType="submit"
                              size="default"
                           >
                              Adicionar Dependente
                           </Button>
                        </Form.Item>
                     </Form>
                  )}
                  {step === 'LIST' && (
                     <div>
                        <div className={'d-flex flex-column'} style={{ gap: 16 }}>
                           {data?.tutor?.map((dependent) => (
                              <div className={'ticket'}>
                                 <div>
                                    <h3>
                                       <FaUser />
                                       {dependent.dependent_name}
                                    </h3>
                                    <div
                                       className={'d-flex align-items-center'}
                                       style={{ gap: 10 }}
                                    >
                                       <div
                                          className={'d-flex align-items-center'}
                                          style={{ gap: 5 }}
                                       >
                                          <FaRegIdCard />
                                          <p style={{ marginBottom: 0 }}>
                                             {maskCpf(dependent.dependent_nin)}
                                          </p>
                                       </div>
                                       <div
                                          className={'d-flex align-items-center'}
                                          style={{ gap: 5 }}
                                       >
                                          <FaStar />
                                          <p style={{ marginBottom: 0 }}>
                                             {moment(dependent.dependent_birthdate).format(
                                                'DD/MM/YYYY'
                                             )}
                                          </p>
                                       </div>
                                    </div>
                                    <button
                                       name={'delete'}
                                       onClick={() =>
                                          onDelete({
                                             remove: dependent.dependent_nin,
                                          })
                                       }
                                    >
                                       <FaTrash />
                                    </button>
                                 </div>
                              </div>
                           ))}
                        </div>

                        <div style={{ textAlign: 'right', marginTop: '16px' }}>
                           <Button
                              type={'primary'}
                              loading={isFetchingDelete}
                              onClick={() => setStep('ADD')}
                              size="default"
                           >
                              Novo dependente
                           </Button>
                        </div>
                     </div>
                  )}
               </div>
            </>
         }
      </Modal>
   );
};

export default Form.create({ name: 'dependent' })(ModalAddDependent);
